import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { WorkStation } from '../work-station'
import { WorkStationDetailComponent } from '../work-station-detail/work-station-detail.component'

@Component({
  selector: 'app-work-station-detail-side',
  templateUrl: './work-station-detail-side.component.html',
  styleUrls: ['./work-station-detail-side.component.scss'],
  imports: [WorkStationDetailComponent],
})
export class WorkStationDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public workStation: WorkStation
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.workStation = route.snapshot.data['workStation']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
